<div class="filter">
    <mat-form-field appearance="fill" class="filter-control">
        <mat-label>Category</mat-label>
        <mat-select [(value)]="selectedCategory" (selectionChange)="onCategoryChange()">
            <mat-option *ngFor="let category of categories" [value]="category">
                {{category.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-control">
        <mat-label>
            <mat-icon>search</mat-icon>
        </mat-label>
        <input matInput type="text" (input)="onSearchStringChange($event)">
        <span *ngIf="searchString != ''" matSuffix class="clickable small-icon" (click)="searchString=''">
            <mat-icon>close</mat-icon>
        </span>
    </mat-form-field>

    <span *ngIf="!allCategoriesShown" class="filter-links">
        Sub-categories:        
        <span class="clickable filter-link" (click)="onClickAllSubCategories()">All</span>
        <span class="clickable filter-link" (click)="onClickNoSubCategories()">None</span>    
    </span>
    <mat-checkbox class="filter-control" *ngFor="let subCategory of selectedCategory.subCategories"
        [checked]="selectedSubCategories[subCategory]" (change)="onSubCategoryChange(subCategory, $event)">
        <span class="sub-category">{{subCategory}}</span>
    </mat-checkbox>
</div>

<div class="equipment-container">
    <div class="table-container">
        <table mat-table matSort [dataSource]="equipmentTableDataSource" class="equipment-table">
            <!-- Column definitions -->
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.category}} </td>
            </ng-container>
            <ng-container matColumnDef="subCategory">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub-Category</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.subCategory}} </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let equipmentItem">
                    <span (click)="selectItem(equipmentItem)" class="clickable small-icon"
                        title="View full description of {{equipmentItem.name}}">
                        <mat-icon>description</mat-icon>
                    </span>
                    <span [class]="equipmentItem.availabilityClass">{{equipmentItem.name}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="damage">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Damage</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.damage}} </td>
            </ng-container>
            <ng-container matColumnDef="rating">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Rating</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.rating}} </td>
            </ng-container>
            <ng-container matColumnDef="shieldHitPoints">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Shield HP</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.shieldHitPoints}} </td>
            </ng-container>
            <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Weight</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.weight}} </td>
            </ng-container>
            <ng-container matColumnDef="durability">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Durability</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.durability}} </td>
            </ng-container>
            <ng-container matColumnDef="design">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Design</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.design}} </td>
            </ng-container>
            <ng-container matColumnDef="notes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.notes}} </td>
            </ng-container>
            <ng-container matColumnDef="hands">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Hands</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.hands}} </td>
            </ng-container>
            <ng-container matColumnDef="range">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Range</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.range}} </td>
            </ng-container>
            <ng-container matColumnDef="availability">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Availability</th>
                <td mat-cell *matCellDef="let equipmentItem"> {{equipmentItem.availability}}% </td>
            </ng-container>
            <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cost</th>
                <td mat-cell *matCellDef="let equipmentItem" [title]="equipmentItem.cost.description">
                    <span (click)="addItemToBuy(equipmentItem)" class="clickable small-icon"
                        title="Add {{equipmentItem.name}} to cost calculator">
                        <mat-icon>paid</mat-icon>
                    </span>
                    {{equipmentItem.cost.displayString}}
                </td>
            </ng-container>

            <!-- Headers -->
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay" color="secondary"></tr>

            <!-- Rows -->
            <tr mat-row *matRowDef="let equipmentItem; columns: columnsToDisplay"></tr>

            <tr *matNoDataRow>
                <td colspan="100%" class="no-data">No matching items found</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 15, 20, 50, 100]" pageSize="20" showFirstLastButtons></mat-paginator>
    </div>

    <div class="right-panel">
        <div *ngIf="!selectedItem">
            <a href="http://arcanumsyndicate.com/demon-gate" target="_blank">
                <img class="logo" src="../../assets/demon-gate-logo.png">
            </a>
        </div>
        <div *ngIf="!!selectedItem" class="details-panel">
            <h2>{{selectedItem.name}}</h2>

            <table class="details-table">
                <tr>
                    <th>Category:</th>
                    <td>{{selectedItem.category}}</td>
                </tr>
                <tr>
                    <th>Sub-category:</th>
                    <td>{{selectedItem.subCategory}}</td>
                </tr>
                <tr *ngIf="selectedItem.shouldShowDamage">
                    <th>Damage:</th>
                    <td>{{selectedItem.damage}}</td>
                </tr>
                <tr *ngIf="selectedItem.shouldShowRating">
                    <th>Rating:</th>
                    <td>{{selectedItem.rating}}</td>
                </tr>
                <tr *ngIf="selectedItem.shouldShowShieldHitPoints">
                    <th>Shield HP:</th>
                    <td>{{selectedItem.shieldHitPoints}}</td>
                </tr>
                <tr>
                    <th>Weight:</th>
                    <td>{{selectedItem.weight}}</td>
                </tr>
                <tr *ngIf="selectedItem.shouldShowDurability">
                    <th>Durability:</th>
                    <td>{{selectedItem.durability}}</td>
                </tr>
                <tr *ngIf="selectedItem.shouldShowDesign">
                    <th>Design:</th>
                    <td>{{selectedItem.design}}</td>
                </tr>
                <tr>
                    <th>Notes:</th>
                    <td>{{selectedItem.notes}}</td>
                </tr>
                <tr *ngIf="selectedItem.shouldShowHands">
                    <th>Hands:</th>
                    <td>{{selectedItem.hands}}</td>
                </tr>
                <tr *ngIf="selectedItem.shouldShowRange">
                    <th>Range:</th>
                    <td>{{selectedItem.range}}</td>
                </tr>
                <tr>
                    <th>Availability:</th>
                    <td>
                        <span>{{selectedItem.availability}}%</span>
                        <span (click)="rollAvailability(selectedItem)" class="clickable small-icon roll-icon"
                            title="Roll to see if this item is available">
                            <mat-icon>casino</mat-icon>
                        </span>
                        <span *ngIf="showRollResults">
                            <span>{{selectedItem.availabilityRollResults}}. Item is </span>
                            <span [class]="selectedItem.availabilityClass">{{selectedItem.isAvailableString.toLowerCase()}}</span>
                            <span>.</span>
                        </span>
                        <span *ngIf="!showRollResults" [class]="selectedItem.availabilityClass">
                            {{selectedItem.isAvailableString}}
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>Cost:</th>
                    <td>{{selectedItem.cost.description}}</td>
                </tr>
            </table>
        </div>

        <div *ngIf="!!itemsToBuy">
            <div class="subtitle-group">
                <h2 class="closer-to-text">Cost Calculator</h2>

                <span (click)="itemsToBuy.clear()" class="clickable link-text" *ngIf="itemsToBuy.size > 0">
                    Remove all items from list
                </span>
            </div>
            <p>
                <span class="small-text">Add items here (using the item's </span>
                <span class="small-icon narrow-icon">
                    <mat-icon>paid</mat-icon>
                </span>
                <span class="small-text"> icon) to see their total cost. You can add an item multiple times.</span>
            </p>

            <table *ngIf="itemsToBuy.size > 0">
                <tr *ngFor="let item of itemsToBuy.keys()">
                    <td (click)="removeItemToBuy(item)" class="clickable small-icon remove-icon"
                        title="Remove 1 {{item.name}} from cost calculator">
                        <mat-icon>remove_circle_outline</mat-icon>
                    </td>

                    <td class="spaced-column">{{itemsToBuy.get(item)}}</td>
                    <td class="spaced-column">{{item.name}}</td>
                    <td class="cost-column">{{item.cost.displayString}}</td>
                </tr>

                <tr class="total-row">
                    <td></td>
                    <td></td>
                    <td>Total:</td>
                    <td class="total-cell cost-column">{{!!itemsToBuyTotalCost ? itemsToBuyTotalCost.displayString: ''}}
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>